import { Outlet } from 'react-router-dom'
import { OrdersTabs } from '@/pages/Orders/OrdersTabs'

export function OrdersLayout() {
  return <><OrdersTabs /><Outlet /></>
}
